import React from 'react';
import { XCircle } from 'lucide-react';
import LclBoardPage from './LclBoardPage';
import { SUBESTADOS_RECHAZADAS } from '../utils/lclBoardConstants';

/**
 * Tablero "Rechazadas" — solicitudes LCL en estado `Rechazada`.
 *
 * Sub-estados (el motivo del rechazo):
 *  - "Cancelada por cliente"
 *  - "Anulada por operador"
 */
export default function LclRejectedBoardPage() {
  return (
    <LclBoardPage
      estado="Rechazada"
      titulo="Operaciones LCL rechazadas"
      subtitulo="Solicitudes canceladas o anuladas · motivo en el sub-estado"
      icon={XCircle}
      iconClass="bg-rose-100 text-rose-700"
      subEstadoOptions={SUBESTADOS_RECHAZADAS}
      subEstadoDefault="Cancelada por cliente"
      exportFileName="lcl_rechazadas"
    />
  );
}
